<template>
  <nav>
    <v-row
      class="fill-height"
      align="center"
      v-if="!loadingData"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <AlertMessages
          v-if="alertValue"
          :alert-type="alertType" 
          :alert-msg="alertMsg"
          @reset="alertValue = false"
        />
        <v-card
          max-width="800"
          elevation="0"
          rounded="xxl"
          color="background"
        > 
          <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
            {{ $t('addWorkflowPeopleTitle') }}
          </v-card-title>
          <v-card-subtitle class="text-body-1 darktext--text d-none d-sm-block no-break">
            {{ $t('addWorkflowPeopleDescription') }}
          </v-card-subtitle>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent
          >

            <v-card-subtitle class="text-body-2 greytext--text ">
              {{ $t('addWorkflowPeopleFieldDescription') }}
            </v-card-subtitle>
            <v-autocomplete
              v-model="selectedUsers"
              :menu-props="{
                rounded: 'xxl'
              }"
              :items="items"
              :loading="isLoading"
              :search-input.sync="search"
              color="white"
              hide-selected
              item-text="searchTerm"
              item-value="id"
              :placeholder="$t('typeToSearch')"
              return-object
              multiple
              chips
              clearable
              solo
              class="rounded-xxl text-body-2 px-1"             
              autofocus                            
              data-testid="users-input"
              @change="change"
              @blur="closeSearch"
            >
              <template v-slot:no-data>
                <p class="mx-5 mt-4">
                  {{ $t('noDataText') }}
                </p>
              </template>
              <template v-slot:selection="data">
                <v-chip
                  v-if="data.item.type == 'users'"
                  v-bind="data.attrs"
                  close
                  data-testid="user-chip"
                  @click:close="remove(data.item)"
                >
                  <v-avatar left>
                    <v-img
                      v-if="data.item.attributes.avatar_thumb == null"
                      src="../../assets/user_images/profile-avatar.png"
                    />
                    <v-img
                      v-else
                      :src="data.item.attributes.avatar_thumb"
                    />
                  </v-avatar>
                  {{ data.item.attributes.first_name }} {{ data.item.attributes.last_name }}
                </v-chip>
                <v-chip
                  v-else
                  v-bind="data.attrs"
                  close
                  data-testid="user-chip"
                  @click:close="remove(data.item)"
                >
                  <v-avatar left>
                    <v-img src="../../assets/user_images/target-group-avatar.png" />
                  </v-avatar>
                  {{ data.item.attributes.name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-avatar
                  v-if="data.item.type == 'users'"
                  rounded="lg"
                >
                  <img
                    v-if="data.item.attributes.avatar_thumb == null"
                    src="../../assets/user_images/profile-avatar.png"
                  >
                  <img
                    v-else
                    :src="data.item.attributes.avatar_thumb"
                  >
                </v-list-item-avatar>
                <v-list-item-avatar
                  v-else
                  rounded="lg"
                >
                  <img
                    v-if="data.item.attributes.avatar_thumb == null"
                    src="../../assets/user_images/target-group-avatar.png"
                  >
                </v-list-item-avatar>
                <v-list-item-content v-if="data.item.type == 'users'">
                  <v-list-item-title>{{ data.item.attributes.first_name + ' ' + data.item.attributes.last_name }} </v-list-item-title>
                  <v-list-item-subtitle> {{ data.item.attributes.email }} </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content v-else>
                  <v-list-item-title>{{ data.item.attributes.name }} </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            
          </v-form>
        </v-card>
        <v-row>
          <v-col align="center">
            <FormFooter
              next-button-text="add"
              :loading="loading"
              :cancel-button-link="cancelLink"
              @proceedSubmit="shareWorkflow"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>             
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { searchSpaceUsersWorkflow,addWorkflowPeople, getWorkflow } from '../../api/workflowApi'
import FormFooter  from '../../components/FormFooter'
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        FormFooter,
        AlertMessages
    },
    data () {
        return {
            spaceId: window.$cookies.get('space_id'),
            selectedUsers: [],
            search: null,
            isLoading: false,
            entries:[],
            alertMsg:'',
            alertValue:false,
            loading: false,
            valid: true,
            showRedError: false,
            message: '',
            workflowId: this.$route.params.id,
            //items: [],
            autocompleteRules: [
                v => {
                    if (!v || v.length < 1){
                        return  i18n.t('labelInputRequired');
                    }
                    else return true;
                }
            ],
            emailRules: [
                v => {
                    if (!v || v.length < 1){
                        return true;
                    }else if (v.length > 0) {
                        for (let i = 0; i < v.length; i++) {
                            if(!(/.+@.+/.test(v[i]))){
                                return i18n.t('emailErrorValid');
                            }
                        }
                        if (this.showRedError) {
                            return i18n.t('showErrorWhenUserIsMember');
                        } else 
                            return true;
                    } 
                    else return true;
                }
            ],
            errors: [],
            loadingData:false,
            cancelLink:'/workflow/'+this.$route.params.id + '/people',
            previousRoute: null,
            roleInSpace: localStorage.space ? JSON.parse(localStorage.space).role : null
        }
    },
    computed: {
        items () {
            return this.entries.map(entry => {
                if (entry.type == 'users') {
                    const searchTerm = entry.attributes.first_name + ' ' + entry.attributes.last_name + ' ' + entry.attributes.email
                    return Object.assign({}, entry, { searchTerm })
                } 
            })
        },
        selectedUsersEmails() {
            return this.selectedUsers.map(entry => {
                if (entry.type == 'users') {
                    if(entry.attributes.email){
                        return entry.attributes.email
                    }
                }
            })
        },
        workflow() {
            return this.$store.state.workflow
        }
    },
    watch: {
      workflow: {
          immediate: true,
          async handler(to) {
            if (to) {
              this.loadingData = true;
              const response = await getWorkflow(this.workflowId)
              if (response.data.data.attributes.member_type == 'email') {
                this.$router.push({ path: '/workflow/' + this.workflowId + '/external/add' });
              }
              if(response.data.data.attributes.is_broken){
                this.$router.push({ name: 'PageAccessDenied' })
              }
              this.loadingData = false;
            }
          },
        },
        async search (val) {
            if (this.isLoading) return 

            var entriesUsers = []
            if(val && val.trim().length >= 2){
                this.isLoading = true
                try {
                    const response = await searchSpaceUsersWorkflow(this.spaceId,this.workflowId, val)
                    if(response.status == 200) {
                        // this.entries = response.data.data
                        entriesUsers = response.data.data
                        entriesUsers.forEach(function(item) {
                            item.sort_term = item.attributes.first_name.toLowerCase() + ' ' + item.attributes.last_name.toLowerCase() + ' ' + item.attributes.email.toLowerCase()
                        })
                    }            
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        if (e.response.status == 403){
                            this.$router.push({name: 'PageAccessDenied'})
                        } else {
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError')
                        }
                    }            
                }
               
                // merge the arrays with users and target groups
                Array.prototype.push.apply(entriesUsers)
                // Sort users and target groups together
                entriesUsers.sort(function(a,b) {return (a.sort_term > b.sort_term) ? 1 : ((b.sort_term > a.sort_term) ? -1 : 0)} )
                this.entries = entriesUsers
                this.isLoading = false
              }    
            /*if(val == null || val == ''){
                this.entries= []
                this.$nextTick(() => {
                    this.entries= []
            })
            }*/ 
            this.isLoading = false
        }
    },
    beforeRouteEnter(to, from, next) {
        if(from.path != null && from.path != '/redirect' && from.path != '/'){
            next(vm => {
                vm.cancelLink = from.path,
                vm.previousRoute = from
            });
        }else { 
            next();
        }
        
    },
    methods: {
        change(){
            this.search = ''
        },
        remove(item) {
            this.selectedUsers.splice(this.selectedUsers.indexOf(item), 1)
            this.selectedUsers = [...this.selectedUsers]
        },
        closeSearch(){
          this.search = ''
          this.entries = this.selectedUsers.slice();
        },
        async shareWorkflow(){
            this.$refs.form.validate()
            if(this.valid && (this.selectedUsers.length) ){
                this.loading = true
                try {
                    let data = {
                        data: {
                            type: "workflow-users", 
                            attributes: {
                                user_email: this.selectedUsersEmails.filter(n => n),
                            }
                        }
                    };
                    const response = await addWorkflowPeople(this.$route.params.id, data)
                    if(response.status == 200) { 
                         if(this.previousRoute){
                            if(this.previousRoute.name !== null){
                                var params = this.previousRoute.params
                                params.peopleAddedInWorkflow = true
                                this.$router.push({name: this.previousRoute.name, params: params})
                            }else {
                                this.$router.push({name: 'PeopleInWorkflow', params: {id: this.$route.params.id, peopleAddedInWorkflow: true}})
                            }
                        }else{
                              this.$router.push({name: 'PeopleInWorkflow', params: {id: this.$route.params.id, peopleAddedInWorkflow: true}})
                        }                  
                    }            
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        if (e.response.status == 403){
                            this.$router.push({name: 'PageAccessDenied'})
                        } else if(e.response.status == 404) {
                            this.$router.push({name: 'PageNotFound'})
                        } else {
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError')
                        }
                    }            
                }
                this.loading =false
            }
            
        },
        

    }
}

</script>